import { AxiosInstance } from "axios";
import axiosBase from "./base";
import {
  ListRootObject,
  RootObject,
} from "view/ProjectDetails/ProjectDetailsModel";
import { PartnersResponse } from "view/Partners/PartnersModel";
import { store } from "store/store";

class AboutService {
  base: AxiosInstance;

  constructor() {
    this.base = axiosBase.base;
  }
  getDocumentsWithAttachment(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `documents?filters[id][$in][0]=2&filters[id][$in][1]=3&populate[attached_document]=id`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getDocuments(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`documents?populate=*`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getInstitutions(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`institutions?populate=*&pagination[pageSize]=9000`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getTeams(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `teams/?populate[cv][populate][attached_document][fields][0]=url&populate[cv][fields][0]=attached_document&populate[photo]=*&pagination[pageSize]=9000`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }

  getProjects(): Promise<ListRootObject> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`projects?populate=*`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getActivityReports(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(`activity-reports?populate[documents][populate]=attached_document`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getLegislationOrganisation(ofType = 'primara'): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `legislations?filters[category]=dsu-organization&filters[type]=${ofType}&populate[documents][populate][attached_document]=id`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getProjectById(id: number): Promise<RootObject> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `projects/${id}?populate=documents,documents.attached_document&populate=cover&populate=gallery`
        )
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
  getPartners(
    typeFilter: string,
    page: number,
    pageSize: number
  ): Promise<PartnersResponse> {
    return new Promise(async (resolve, reject) => {
      this.base
        .get(
          `partners?populate=*&filters[type][$eq]=${typeFilter}&pagination[page]=${page}&pagination[pageSize]=${pageSize}`
        )
        .then(({ data }) => {
          // console.log("parteneri", data);
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }

  getQualityManagementDocuments(ids: number[]): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if (ids.length === 0) {
        return resolve([]);
      }
      const filters = ids
        .map((id, index) => `filters[id][$in][${index}]=${id}`)
        .join("&");
      this.base
        .get(`documents?${filters}&populate=*`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }

  getAttribution(): Promise<any[]> {
    return new Promise(async (resolve, reject) => {
      const state = store.getState();
      const language = state.language.language;

      this.base
        .get(`attribution?locale=${language}`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
}
const aboutService = new AboutService();
export default aboutService;
